export const sidebarType = {
  SET_COLLAPSED: "SET_COLLAPSED",
};
